module.exports = __webpack_public_path__ + "static/media/1033162.109760cb.jpg";